import type { ClientLocationPlan } from "api-types/locationPlans/locationPlansResponses";
import type { ClientMasterPlan } from "api-types/masterPlans/masterPlansResponses";
import OptimizedImage from "ui/components/OptimizedImage";
import { getPlanThumbnailUrl } from "./PlanThumbnail";

interface PlanThumbnailCellProps {
  /** The plan data - either a community plan or master plan */
  plan: ClientLocationPlan | ClientMasterPlan;
  /** Optional CSS class name for the container */
  className?: string;
  /** Width of the optimized image */
  width?: number;
  /** Alt text for the image */
  alt?: string;
}

/**
 * Reusable thumbnail cell component for plan tables
 * Handles both community plans and master plans
 */
export default function PlanThumbnailCell({
  plan,
  className,
  width = 150,
  alt = "Plan elevation thumbnail",
}: PlanThumbnailCellProps) {
  // Determine if this is a master plan or community plan based on properties
  const isMasterPlan = "builderId" in plan && !("locationId" in plan);

  const thumbnailUrl = getPlanThumbnailUrl(
    isMasterPlan ? { masterPlan: plan as ClientMasterPlan } : { communityPlan: plan as ClientLocationPlan },
  );

  return (
    <div className={className}>
      <OptimizedImage src={thumbnailUrl} alt={alt} width={width} />
    </div>
  );
}
